<template>
  <div class="web-wrapper">
      <div>UNDER CONSTRUCTION</div>
  </div>
</template>

<script>
export default {
  name: "Web",
};
</script>

<style lang="sass-loader">

</style>



// WEBPACK FOOTER //
// src/components/projects/Web.vue